import React, { FC } from 'react';
import RadioIcon, { OptionButton } from '~Components/RadioOptions';
import { useStorage } from '~Components/Storage';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useButton, useI18n } from '~Hooks';
import { GetPosDevices_devices } from '~Scenes/Onboarding/api/__queries__';
import { Box } from '~Styles';

interface Props {
  posDevice: GetPosDevices_devices;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const SelectableDevice: FC<Props> = ({ posDevice, isSelected, onSelect }) => {
  const { i18n } = useI18n();

  const [storage] = useStorage();

  const selectButton = useButton({
    onClick: () => {
      if (isUsedByThisDevice) {
        return;
      }

      onSelect(posDevice.id);
    },
  });

  const isUsedByThisDevice = posDevice?.id === storage.deviceId;

  return (
    <OptionButton selected={isSelected} {...selectButton} disabled={isUsedByThisDevice}>
      <RadioIcon active={isSelected} />
      <Box display="flex" alignItems="center" justifyContent="space-between" fluid>
        <Box display="flex" flexDirection="column">
          <Heading level={4} bottom={0} color="var(--colorWhite)">
            {posDevice.name}{' '}
            {posDevice?.claimed &&
              `(${
                isUsedByThisDevice
                  ? i18n('Onboarding.Select.InUseByThisDevice')
                  : i18n('Onboarding.Select.InUse')
              })`}
          </Heading>
        </Box>
      </Box>
    </OptionButton>
  );
};

export default SelectableDevice;
